module.exports = __webpack_public_path__ + "static/building_all_2-731316e09e5143cecbb6e00ad74a5b19.jpg";